import {reqWithToken} from './requestHelper';


export async function removeFile(params){
    return await reqWithToken('api/gxbooking/upload', {
        method: 'Delete',
        params
    });
}

export async function download(params){
    return (await reqWithToken('api/gxbooking/upload', {
        params,
        responseType: 'blob'
    })).data;
}